export default __webpack_public_path__ + "static/media/0.e68bd4f4.png";